import { AdminAuthService } from '@/services/administradores/admin-auth.service'
// import api from '@/services/api'
import { defineStore } from 'pinia'

function decodeJwtPayload(token: string): { id: string; nome: string; email: string; root: boolean } {
  const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
  return JSON.parse(atob(base64));
}

export const useAuthStoreAdmin = defineStore('authAdmin', {
  state: () => ({
    initialized: false,
    isLoggedIn: false,
    adminInfo: null as { id: string; nome: string; email: string; root: boolean } | null,
    service: new AdminAuthService(),
  }),
  actions: {
    async init() {
      if (this.initialized) return;
      if (window.location.pathname === 'admin')
        return this.initialized = true;
      this.isLoggedIn = await this.service.isLoggedIn();
      if (this.isLoggedIn) {
        const info = await this.service.whoAmI();
        this.adminInfo = info || null;
      }
      this.initialized = true;
    },
    async login(email: string, senha: string) {
      try {
        const result = await this.service.login(email, senha) as { accessToken: string };
        this.isLoggedIn = true;
        return true;
      } catch (e) {
        console.warn(e);
        return false;
      }
    },
    async logout() {
      await this.service.logout();
      this.isLoggedIn = false;
      this.adminInfo = null;
    },
  },
})